import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-153b1002"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoices" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Fakturaoversikt", -1))
const _hoisted_3 = {
  key: 0,
  class: "invoices-table"
}
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvoicesTable = _resolveComponent("InvoicesTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.invoices)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_InvoicesTable, { invoices: _ctx.invoices }, null, 8, ["invoices"]),
          (_ctx.invoices?.total === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Ingen resultat"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}